import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class StoreAdminAuthGuard implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      const resetUrlToRedirect = window.location.pathname + window.location.search;
    if (localStorage.getItem('userToken') !== null && localStorage.getItem('userToken') !== undefined &&
      localStorage.getItem('userToken') !== '' && localStorage.length !== 0 && (localStorage.getItem('role') === 'StoreAdmin' || localStorage.getItem('role') === 'StoreOwner' || localStorage.getItem('role') === 'StoreStaffMember')) {
      return true;
    } else {

      window.localStorage.setItem('urlToRedirect', resetUrlToRedirect);
      this.router.navigate(['/']);
      return false;
    }
  }
}
